module.exports = am4plugins_sunburst;